import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import ReactQuill from "react-quill";
import $ from "jquery";
import Drawer from "@material-ui/core/Drawer";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { textinputconverter } from "../../../../../../Component/DynamicForm/Fields/Text";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import SectionHeaderExtraSmall from "../../../../../../Component/Headers/sectionHeaderExtraSmall";
import "react-quill/dist/quill.core.css";
import "./index.scss";
import { instance } from "../../../../../../Actions/AxiosInstance";
import { ErrorMessages } from "../../../../../../Constants";
import DrawerHeader from "../../../../../../Component/Headers/drawerHeader";
import { textareainputconverter } from "../../../../../../Component/DynamicForm/Fields/Textarea";
import { isSpaceInString } from "Utils";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
];

class ComposeLetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 2,
      open: false,
      modules: props.modules1,
      formats,
      templatebody: props.templatebody || '',
      templatename: props.postData.templatename || '',
      categoryname: '',
      description: '',
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
    this.openDoc = this.openDoc.bind(this);
    this.updateChange = this.updateChange.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitReq = this.submitReq.bind(this);
  }

  componentDidMount() {
    const x = () => {
      $("span").removeClass("ql-selected");
    };
    x();
    const placeholderPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-placeholder .ql-picker-item'));
    placeholderPickerItems.forEach((item) => item.textContent = item.dataset.value);
    document.querySelector('.ql-placeholder .ql-picker-label').innerHTML = '{ }';
  }

  componentWillUnmount() {
    const { templatename, templatebody } = this.state;
    const { postData } = this.props;
    postData.templatename = templatename;
    this.props.updateBody("templatebody", templatebody);
    this.props.updatePostData(postData);
  }

  openDoc() {
    const { letterVariables } = this.props;
    const bodyvariableids = [];
    letterVariables.forEach((x) => {
      if (this.state.templatebody && this.state.templatebody.includes(`{${x.variablevalue}}`)) {
        bodyvariableids.push(x.displayvalue);
      }
    });
    const data = {
      "isongoing": true,
      templatebody: this.state.templatebody,
      variableids: bodyvariableids.join(",") || null,
    };
    instance.post("letter/previewtemplate", data)
    .then((result) => {
      const link = `data:application/pdf;base64,${result.data.result[0].content.buffer.data}`;
      this.props.setPreview({ show: true, type: "doc", data: link, name: "Template.pdf", ext: 'pdf', isbase64: true });
    })
    .catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  onSubmit() {
    if (this.state.templatename && !isSpaceInString(this.state.templatename)) {
      this.state.templatename = this.state.templatename.trim();
    }
    this.props.onNextClick();
  }

  updateChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  updatePostData(key, value) {
    const { postData } = this.props;
    if (key == "lettercategoryid") {
      postData[key] = value;
      this.props.updatePostData(postData);
    }
    this.setState({
      x: 's',
    });
  }

  handleChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  submitReq() {
    const { categoryname, description } = this.state;
    if (categoryname) {
      instance.post("letter/createlettercategoryrequest", { categoryname, description })
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.setState({
          open: false,
          categoryname: '',
          description: '',
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    } else {
      this.props.enqueueSnackbar("Please enter category name", { variant: "error" });
    }
  }

  openDrawer() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    return (
      <div>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6} sm={12}>
            <DynamicForm
              fields={selectinputconverter({
                value: this.props.postData.lettercategoryid,
                options: this.props.lettercategories,
                placeholder: "Select category",
                label: "Category",
              })}
              onChange={(e) => this.updatePostData("lettercategoryid", e)}
            />
            <div style={{ fontSize: 14, color: "#1e8ced" }}
              className="cursor-pointer"
              onClick={this.openDrawer}
            >
              Do not find a category of your suiting? Request here.
            </div>
          </Grid>
          <Grid item xs={12} md={6} sm={12}>
            <DynamicForm
              fields={textinputconverter({
                value: this.state.templatename,
                label: "Template name",
                placeholder: "Enter name",
              })}
              onChange={(e) => this.updateChange("templatename", e)}
            />
          </Grid>
        </Grid>
        <Grid container className="margin-top-24">
          <Grid item xs={12} md={12} sm={12}>
            <p className="small-dark-secondary">
              Make a contextual letter by using variables as placeholders.
            </p>
            <div className="margin-top-8 margin-bottom-8">
              <ReactQuill
                theme="snow"
                value={this.state.templatebody || ""}
                modules={this.state.modules}
                formats={this.state.formats}
                onChange={(e) => this.updateChange("templatebody", e)}
              />
            </div>
            <div className="display-table">
              <SectionHeaderExtraSmall header="📌 Press ‘ { } ‘ to see a selectable list of all possible placeholder variables." />
            </div>
          </Grid>
        </Grid>

        <Grid container>
          <div style={{ marginTop: 20 }}>
            <Button
              color="primary"
              className="btn btn-secondary-md-blue margin-right-16"
              variant="contained"
              onClick={this.openDoc}
            >
              Preview
            </Button>
            <Button
              color="primary"
              className="btn btn-secondary-md-blue"
              variant="contained"
              onClick={this.onSubmit}
            >
              Next
            </Button>
          </div>
        </Grid>
        <Drawer
          anchor="right"
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
          classes={{
            paper: "planner-drawer padding15 width25",
          }}
        >
          <DrawerHeader
            header="New category request"
            isbackarrow={false}
            closeDrawer={this.openDrawer}
          />
          <div>
            <DynamicForm
              fields={textinputconverter({
                value: this.state.categoryname,
                placeholder: "Enter Category name",
                label: "Category name ",
              })}
              onChange={(value) => {
                this.handleChange("categoryname", value);
              }}
            />
          </div>
          <div>
            <DynamicForm
              fields={textareainputconverter({
                value: this.state.description,
                placeholder: "Enter description",
                label: "Description",
              })}
              onChange={(value) => {
                this.handleChange("description", value);
              }}
            />
          </div>
          <div style={{ marginTop: 20 }}>
            <Button
              variant="contained"
              className="btn btn-primary-md-blue margin-right-16"
              color="primary"
              onClick={this.submitReq}
            >
              Send request
            </Button>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default withSnackbar(ComposeLetter);
